import { render, staticRenderFns } from "./MproductView.vue?vue&type=template&id=72f8ddc5&scoped=true"
import script from "./MproductView.vue?vue&type=script&lang=js"
export * from "./MproductView.vue?vue&type=script&lang=js"
import style0 from "./MproductView.vue?vue&type=style&index=0&id=72f8ddc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f8ddc5",
  null
  
)

export default component.exports